import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';

import { Messages } from 'features/chat/config/types/Message';

type ChatHistoryQueryProps = {
  chatId: string;
  enabled?: boolean;
  limit: number;
  fromMessageId?: string;
  direction?: 'up' | 'down';
  staleTime?: number;
};

const CHAT_MESSAGES_TO_LOAD = 20;

export const useChatHistoryQuery = ({
  chatId,
  enabled = true,
  limit = CHAT_MESSAGES_TO_LOAD,
  fromMessageId,
  direction,
  staleTime,
}: ChatHistoryQueryProps) => {
  const { request } = useQueryHTTPRequest();

  return useQuery<{ messages: Messages }, unknown, Messages>(
    [queryKeys.chatMessagesHistory, chatId, limit, fromMessageId, direction],
    () => {
      const urlSearchParams = new URLSearchParams({
        limit: limit.toString(),
      });

      if (fromMessageId) {
        urlSearchParams.append('from_message_id', fromMessageId);
      }

      if (direction) {
        urlSearchParams.append('direction', direction);
      }

      return request({
        url: `/api/chats/${chatId}/history?${urlSearchParams.toString()}`,
      });
    },
    {
      select: (data) => data.messages,
      enabled,
      staleTime,
    }
  );
};
